import { z } from "zod";

export const consentDocumentFileResponseSchema = z.object({
  created_at: z.string(),
  deleted_at: z.string().optional(),
  path: z.string(),
});

export const consentDocumentResponseSchema = z.object({
  id: z.uuid(),
  organization_id: z.uuid(),
  name: z.string(),
  files: z.array(consentDocumentFileResponseSchema),
});

export const addDocumentFormSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters"),
  file: z.instanceof(File, { error: "File is required" }),
});

export const updateDocumentFormSchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(100, "Name must be less than 100 characters"),
  file: z.union([consentDocumentResponseSchema, z.instanceof(File)]).optional(),
});

export const signConsentDocumentResponseSchema = z.object({
  consent_form_name: z.string(),
  organization_consent_form_file: consentDocumentFileResponseSchema,
  created_at: z.string(),
});
